











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {PosicaoMotorista} from '@/model/resource/PosicaoMotorista'
import {PosicaoMotoristaCollection} from '@/model/collection/PosicaoMotoristaCollection'
import {ListPosicaoMotoristaSchema} from '@/schema/resource/PosicaoMotorista/ListPosicaoMotoristaSchema'
import {CsvPosicaoMotoristaSchema} from '@/schema/resource/PosicaoMotorista/CsvPosicaoMotoristaSchema'

@Component
export default class ListPosicaoMotoristaView extends Mixins(MixinQueryRouter) {
  schema = new ListPosicaoMotoristaSchema()
  collection = new PosicaoMotoristaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: PosicaoMotorista) {
    Helper.pushByName('editPosicaoMotorista', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new PosicaoMotoristaCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvPosicaoMotorista()
    new CsvPosicaoMotoristaSchema().downloadCsv(csv.all())
  }
}
